import cn from "classnames";
import styles from "./FieldAdminIncome.module.scss";
import { IFieldAdminIncomeProps } from "./FieldAdminIncome.props";
import { memo, useEffect, useRef, useState } from "react";
import { useMe, useSettings, useSettingsNames } from "@utils/hooks/useMe";
import { useIntl } from "react-intl";
import { dev } from "@utils/dev";
import { IStoredSetting } from "@store/me/actionTypes";
import CleanupButton from "@components/global/CleanupButton";
import { Input } from "../Input/Input";
import { MINER_SETTINGS_E } from "@services/getMinerList";
import PoolSelector from "../PoolSelector/PoolSelector";

function FieldAdminIncome({
  name,
  className,
  defaultValue,
  oldValue,
  reset,
  admin_setting,

  getValue,
  ...props
}: IFieldAdminIncomeProps) {
  const { formatMessage } = useIntl();
  const settings = useSettings();
  const [inputValue, setInputValue] = useState("");
  const [pool, setPool] = useState<number>();
  const isInitialMount = useRef(true);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else if (getValue) {
      if (inputValue.length === 0) {
        getValue("0");
      } else {
        getValue(inputValue);
      }
    }
  }, [inputValue]);

  return (
    <>
      <Input
        type="number"
        max={100}
        size="small"
        id={props.id}
        value={inputValue}
        onChange={(e) => {
          setInputValue(String(e.currentTarget.value));
        }}
        onBlur={() => {
          props.onChange?.(inputValue.length ? inputValue : "0", pool);
        }}
        label={<span className={styles.label}>{name}</span>}
        addonAfter="%"
        suffix={
          inputValue &&
          inputValue !== "0" && (
            <span className={styles.suffix}>
              {settings.find((s) => String(s.id) === admin_setting)?.name}
            </span>
          )
        }
        allowClear
      />
      {!!inputValue && inputValue !== "0" && (
        <PoolSelector
          name={formatMessage({ id: "machines.settings.adminMiningPool" })}
          id={MINER_SETTINGS_E.ADMIN_SETTING}
          hasCleanUp
          getPoolValue={(value) => {
            setPool(value?.id);
            props.onChange?.(inputValue.length ? inputValue : "0", value?.id);
          }}
        />
      )}
    </>
  );
}

export default memo(FieldAdminIncome);
